import React, { useState, useEffect, useMemo } from "react";
import {
  Form,
  Select,
  Input,
  InputNumber,
  Row,
  Col,
  Typography,
  message,
  Spin,
  Space,
} from "antd";
import { SearchOutlined, LoadingOutlined } from "@ant-design/icons";
import axios from "axios";
import debounce from "lodash/debounce";
import { FETCH_ALL_ARTICLE_API } from "../../../../Constants/Apis";

const { Text } = Typography;
const { Option } = Select;

const SkuEditForm = ({ modalForm, isEditMode, isTempEditMode, stockData }) => {
  useEffect(() => {
    if (isEditMode && stockData) {
      modalForm.setFieldsValue({
        article: stockData.article,
        color: stockData.color,
        size: stockData.size,
        assort: stockData.assort,
        price: stockData.price,
        harga_internal: stockData.harga_internal,
        quantity: stockData.quantity,
        currentQuantity: stockData.currentQuantity,
        barcode: stockData.barcode,
        sku: stockData.sku,

        _id: stockData._id, // Add this line to preserve the ID
      });
    }
  }, [isEditMode, stockData, modalForm, isTempEditMode]);

  return (
    <Form form={modalForm} layout="vertical">
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            label="SKU"
            name="sku"
            rules={[{ required: true, message: "Please input SKU!" }]}
          >
            <Input type="text" />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default SkuEditForm;
